module.exports = __webpack_public_path__ + "static/media/LILL-GLOCK.6d517d39.png";